import styled from "styled-components";

export const MuiEllipseLabelWrapper = styled.div`
  display: flex;
  align-items: center;

  .ellipse {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }

  .ellipse-label-box {
    width: 100%;
  }

  .with-cursor-pointer {
    cursor: pointer;
  }
`;
